import './dashboard.scss';
import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { addMessage } from 'researcher/application/actions';
import { addPreferredGroup, removePreferredGroup } from 'researcher/user/actions';
import { fetchOrders, updateCertificate, getDownloadUrl } from '../actions';
import { getDigitalOrdersLinkTerm, getOrders } from '../reducer';
import Dashboard from './Dashboard';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    dashboard = _ref.dashboard,
    digitalOrders = _ref.digitalOrders,
    user = _ref.user;
  var match = _ref2.match,
    pathname = _ref2.location.pathname;
  return {
    companyShortName: application.companyShortName,
    digitalOrdersLinkTerm: getDigitalOrdersLinkTerm({
      digitalOrders: digitalOrders
    }),
    orderFormInProgress: user.orderFormInProgress,
    pagination: dashboard.orders.pagination,
    pathname: pathname,
    searchParams: match.params,
    status: dashboard.orders.status,
    orders: getOrders({
      dashboard: dashboard
    }),
    unpaidInvoices: user.unpaidInvoices,
    user: user
  };
};
var mapDispatchToProps = {
  addMessage: addMessage,
  addPreferredGroup: addPreferredGroup,
  fetchOrders: fetchOrders,
  removePreferredGroup: removePreferredGroup,
  updateCertificate: updateCertificate,
  getDownloadUrl: getDownloadUrl
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));